/**
 * Module that deals with organizations and their data.
 **/

export const ORG_ROLE = {
  CARRIER: "CARRIER",
  SHIPPER: "SHIPPER",
};
